import { ScreenReaderText } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  ScreenReaderText,
  React
};